<app-header></app-header>

<ion-content
  scrollbar
  class="space-reservations__container ion-content-padding-top-0"
>
  <ion-fab
    *ngIf="p.renderMobile && equipmentAddRole"
    vertical="bottom"
    horizontal="end"
    slot="fixed"
  >
    <ion-fab-button (click)="onEditEquipment(0)">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <ion-grid>
    <app-list-header [hideHeader]="true" [hideSeparator]="true">
      <ng-container top>
        <app-search-bar
          (searchEvent)="onChangeSearch($event)"
          [permissionEdit]="equipmentAddRole"
          buttonAddLabel="{{ 'EQUIPMENT.ADD' | translate}}"
          (addClickEvent)="onEditEquipment(0)"
          [onAddClickEvent]="true"
        >
        </app-search-bar>
      </ng-container>
    </app-list-header>

    <app-pagination-client-side
      [columns]="columnsDefinition"
      [componentRef]="componentRef"
      (rowsLoaderReady)="rowsLoaderServiceReady($event)"
      (actionRequest)="handleActionRequest($event)"
      (refreshRequest)="refreshEquipments()"
    >
    </app-pagination-client-side>
  </ion-grid>
</ion-content>

<!-- <div *ngIf="!p.renderMobile" class="margin-bottom-4">
  <app-breadcrumb></app-breadcrumb>
</div> -->
